export default {
    deliveryChannel: '',
    market: '',
    partner: {},
    modifiers: {
        theme: '',
        isShowCopyright: null,
        closeList: '',
        headerBackground: '',
        containerType: '',
        isSideButton: null
    }
}
